(function($, w) {
    if (!localStorage.getItem('user_id') || !localStorage.getItem('token')) return;
    if (w.location.pathname === '/acesso') return;

    function vitrineHeaders() {
        var h = { 'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content') || '' };
        var token = localStorage.getItem('token');
        if (token) h['Authorization'] = 'Bearer ' + token;
        return h;
    }

    function init() {
        var userId = localStorage.getItem('user_id');

        $.ajax({
            url: '/vitrine-consent/check',
            data: { user_id: userId },
            dataType: 'json',
            headers: vitrineHeaders()
        }).done(function(data) {
            if (!data || !data.show) return;
            showConsentModal(userId);
        });
    }

    function showConsentModal(userId) {
        var $modal = $('#vitrine-consent-modal');
        if (!$modal.length) return;

        var $checkbox = $('#vitrine-consent-check');
        var $saveBtn = $('#vitrine-consent-save');
        var $skipBtn = $('#vitrine-consent-skip');
        var saving = false;

        $checkbox.prop('checked', false);

        $saveBtn.off('click').on('click', function() {
            if (saving) return;
            saving = true;
            $saveBtn.prop('disabled', true).text('Salvando...');

            $.ajax({
                url: '/vitrine-consent',
                method: 'POST',
                data: {
                    user_id: userId,
                    vitrine_consent: $checkbox.is(':checked') ? 1 : 0
                },
                headers: vitrineHeaders()
            }).done(function() {
                $modal.modal('hide');
            }).fail(function() {
                alert('Não foi possível salvar sua preferência. Tente novamente.');
            }).always(function() {
                saving = false;
                $saveBtn.prop('disabled', false).text('Salvar preferência');
            });
        });

        $skipBtn.off('click').on('click', function() {
            if (saving) return;
            saving = true;
            $skipBtn.prop('disabled', true);

            $.ajax({
                url: '/vitrine-consent',
                method: 'POST',
                data: {
                    user_id: userId,
                    vitrine_consent: 0
                },
                headers: vitrineHeaders()
            }).done(function() {
                $modal.modal('hide');
            }).fail(function() {
                $modal.modal('hide');
            }).always(function() {
                saving = false;
                $skipBtn.prop('disabled', false);
            });
        });

        $modal.modal('show');
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', init);
    } else {
        init();
    }
})(jQuery, window);
